import { useEffect, useState } from 'react';

export const useShowLoadingScreen = () => {
  const [showLoadingScreen, setShowLoadingScreen] = useState(true);
  useEffect(() => {
    setTimeout(() => setShowLoadingScreen(false), 1300);
  }, [showLoadingScreen]);
  return showLoadingScreen;
};
